let eventsPool = {};
window.events = {}

window.events.callEvent = (eventName, ...args) => {
    let called = false;

    if (eventsPool[eventName]) {
        eventsPool[eventName](...args);
        called = true;
    }

    // Также вызываем window.functionList (addListernEvent)
    if (window.functionList && typeof window.functionList[eventName] === 'function') {
        window.functionList[eventName](...args);
        called = true;
    }

    return called;
};

window.events.addEvent = (eventName, callback) => {
    window.events.removeEvent(eventName);
    eventsPool [eventName] = callback;
};

window.events.removeEvent = (eventName) => {

    if (eventsPool [eventName]) {
        eventsPool [eventName] = null;
        delete eventsPool [eventName];
    }
};